var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCashOutSession(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_777_8597)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.58333 10.4211C3.32686 10.4211 2.31481 11.4461 2.31481 12.7025V23.2803C2.31481 24.5367 3.32685 25.5618 4.58333 25.5618H24.4167C25.6731 25.5618 26.6852 24.5367 26.6852 23.2803V12.7025C26.6852 11.4461 25.6731 10.4211 24.4167 10.4211H20.3333C19.979 10.4211 19.6852 10.1306 19.6852 9.76427C19.6852 9.39792 19.979 9.10748 20.3333 9.10748H24.4167C26.3819 9.10748 27.9815 10.7134 27.9815 12.7025V23.2803C27.9815 25.2694 26.3819 26.8754 24.4167 26.8754H4.58333C2.61814 26.8754 1.01852 25.2694 1.01852 23.2803V12.7025C1.01852 10.7134 2.61814 9.10748 4.58333 9.10748H8.66667C9.02102 9.10748 9.31482 9.39792 9.31482 9.76427C9.31482 10.1306 9.02102 10.4211 8.66667 10.4211H4.58333ZM14.5 15.1223C12.9213 15.1223 11.6481 16.4104 11.6481 17.9914C11.6481 19.5724 12.9213 20.8606 14.5 20.8606C16.0787 20.8606 17.3519 19.5724 17.3519 17.9914C17.3519 16.4104 16.0787 15.1223 14.5 15.1223ZM10.3519 17.9914C10.3519 15.6778 12.2126 13.8087 14.5 13.8087C16.7873 13.8087 18.6481 15.6778 18.6481 17.9914C18.6481 20.305 16.7873 22.1741 14.5 22.1741C12.2126 22.1741 10.3519 20.305 10.3519 17.9914ZM6.33333 14.984C6.6877 14.984 6.98148 15.2744 6.98148 15.6408V20.342C6.98148 20.7084 6.6877 20.9988 6.33333 20.9988C5.97897 20.9988 5.68519 20.7084 5.68519 20.342V15.6408C5.68519 15.2744 5.97897 14.984 6.33333 14.984ZM22.6667 14.984C23.021 14.984 23.3148 15.2744 23.3148 15.6408V20.342C23.3148 20.7084 23.021 20.9988 22.6667 20.9988C22.3123 20.9988 22.0185 20.7084 22.0185 20.342V15.6408C22.0185 15.2744 22.3123 14.984 22.6667 14.984ZM2.83459 12.6351C2.86977 11.6927 3.63924 10.9396 4.58333 10.9396H8.66667C9.31099 10.9396 9.83333 10.4134 9.83333 9.76427C9.83333 9.11517 9.31099 8.58896 8.66667 8.58896H4.58333C2.32817 8.58896 0.5 10.4307 0.5 12.7025V12.7024C0.5 10.4306 2.32817 8.58887 4.58333 8.58887H8.66667C9.31099 8.58887 9.83333 9.11508 9.83333 9.76418C9.83333 10.4133 9.31099 10.9395 8.66667 10.9395H4.58333C3.63921 10.9395 2.86972 11.6927 2.83459 12.6351Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6133 6.83325L14.5022 3.49992L18.3911 6.83325",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5039 3.83341L14.5039 11.1667",
    stroke: "white",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_777_8597"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashOutSession);
export default __webpack_public_path__ + "static/media/cash_out_session.1addf526ad399f246ddd833b848a7a2c.svg";
export { ForwardRef as ReactComponent };